import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FontObserverService {
  private fontsLoadedSubject = new BehaviorSubject<boolean>(false);
  public fontsLoaded$ = this.fontsLoadedSubject.asObservable();

  constructor() {
    this.waitForMaterialSymbols();
  }

  private waitForMaterialSymbols() {
    if (!document.fonts || typeof document.fonts.load !== 'function') {
      this.markLoaded();
      return;
    }

    const FALLBACK_MS = 5000;

    Promise.race([
      document.fonts.load('24px "Material Symbols Outlined"'),
      new Promise((resolve) => setTimeout(resolve, FALLBACK_MS)),
    ]).finally(() => this.markLoaded());
  }

  private markLoaded() {
    if (this.fontsLoadedSubject.value) return;
    document.body.classList.add('fonts-loaded');
    this.fontsLoadedSubject.next(true);
  }
}
